import React from 'react';
import TitleList from "./TitleList";

function Home() {
  return (
    <main>
      <p>
        Welcome to <b>Microblog</b>. Stay a while and listen.
      </p>
      <TitleList />
    </main>
  );
}

export default Home;